/* __next_internal_client_entry_do_not_use__ HeaderCategoriesButton auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useNextRouterContext } from "@faire/retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { LazyHeaderCategoriesDropdown } from "@faire/retailer-visitor-shared/components/Header/desktop/HeaderCategoriesDropdown/LazyCategoriesDropdown";
import { HeaderDropdown } from "@faire/retailer-visitor-shared/components/Header/styled";
import { useIsHeaderDropdownVisible } from "@faire/retailer-visitor-shared/components/HeaderPriorityRenderer/useIsHeaderDropdownVisible";
import { Chevron } from "@faire/retailer-visitor-shared/icons/Chevron/Chevron";
import { useChatBubbleStore } from "@faire/retailer-visitor-shared/packages/messenger/views/useChatBubbleStore";
import { useSettingNextJSRscCategoryPage } from "@faire/retailer-visitor-shared/settings/useSettingNextJSRscCategoryPage";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Close } from "@faire/web--source/slate/icons/Close";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import ClickOutside from "@faire/web--source/ui/ClickOutside";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackNavigationTreeUxCategoriesMenuButtonClick } from "@faire/web-api--source/events/navigationTreeUx/click/categoriesMenuButton";
import { trackNavigationTreeUxCategoriesMenuButtonView } from "@faire/web-api--source/events/navigationTreeUx/view/categoriesMenuButton";
import { route as categoryC1Route } from "@faire/web-api--source/routes/category/c1CategoryUrlId";
import React, { Suspense, useCallback, useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
export var HeaderCategoriesButton = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useNextRouterContext = useNextRouterContext(), nextPrefetch = _useNextRouterContext.prefetch;
    var _useState = _sliced_to_array(useState(false), 2), shouldShowDropdown = _useState[0], setShouldShowDropdown = _useState[1];
    var buttonRef = useRef(null);
    var setHeaderDropdownVisibility = useIsHeaderDropdownVisible().setHeaderDropdownVisibility;
    var _useChatBubbleStore = _sliced_to_array(useChatBubbleStore([]), 2), setChatBubbleStore = _useChatBubbleStore[1];
    var isRSCCategoryPageEnabled = useSettingNextJSRscCategoryPage();
    var toggleHandler = useCallback(function(shouldShowDropdown, isUserClick) {
        setShouldShowDropdown(shouldShowDropdown);
        setHeaderDropdownVisibility("CATEGORIES", shouldShowDropdown);
        if (shouldShowDropdown) {
            setChatBubbleStore({
                isShowingChat: false
            });
        }
        if (isUserClick) {
            trackNavigationTreeUxCategoriesMenuButtonClick(shouldShowDropdown ? "OPEN" : "CLOSE");
            if (shouldShowDropdown && !isRSCCategoryPageEnabled) {
                nextPrefetch(categoryC1Route);
            }
        }
    }, [
        setHeaderDropdownVisibility,
        setChatBubbleStore,
        isRSCCategoryPageEnabled,
        nextPrefetch
    ]);
    useEffect(function() {
        trackNavigationTreeUxCategoriesMenuButtonView();
    }, []);
    var closeDropdown = useCallback(function() {
        var _buttonRef_current;
        toggleHandler(false, false);
        (_buttonRef_current = buttonRef.current) === null || _buttonRef_current === void 0 ? void 0 : _buttonRef_current.blur();
    }, [
        toggleHandler
    ]);
    return /*#__PURE__*/ _jsxs(ClickOutside, {
        onClickOutside: closeDropdown,
        children: [
            /*#__PURE__*/ _jsxs(DropdownButton, {
                buttonRef: buttonRef,
                onClick: function() {
                    return toggleHandler(!shouldShowDropdown, true);
                },
                "aria-label": strictLocalize({
                    id: "P9kdue",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "All categories"
                        }
                    ]
                }),
                "aria-haspopup": "menu",
                variant: "tertiary",
                $isSelected: shouldShowDropdown,
                children: [
                    /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "P9kdue",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "All categories"
                            }
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "1x"
                    }),
                    /*#__PURE__*/ _jsx(IconWrapper, {
                        children: shouldShowDropdown ? /*#__PURE__*/ _jsx(Close, {}) : /*#__PURE__*/ _jsx(Chevron, {
                            direction: "down"
                        })
                    })
                ]
            }),
            shouldShowDropdown ? /*#__PURE__*/ _jsx(HeaderDropdown, {
                $right: "0px",
                $width: "100vw",
                $noBoxShadow: true,
                children: /*#__PURE__*/ _jsx(Suspense, {
                    fallback: null,
                    children: /*#__PURE__*/ _jsx(LazyHeaderCategoriesDropdown, {
                        handleCloseMenu: closeDropdown
                    })
                })
            }) : null
        ]
    });
};
var DropdownButton = styled(Button).withConfig({
    componentId: "sc-bb68634f-0"
})([
    "padding:",
    ";text-decoration:none;border-radius:",
    ";",
    " &:hover,&:focus{background-color:",
    ";text-decoration:none;}"
], getSpacing(10, "2x"), getSpacing("4x"), function(props) {
    return props.$isSelected ? css([
        "background-color:",
        ";text-decoration:none;"
    ], Core.surface.subdued) : "";
}, Core.surface.subdued);
var IconWrapper = styled.div.withConfig({
    componentId: "sc-bb68634f-1"
})([
    "svg{width:8px;height:8px;stroke-width:1.5;}"
]);
